import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { blogPosts } from './blog/posts';
export function BlogPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Blog | IntelliEats';
    // Google AdSense - inject into <head>
    if (!document.querySelector('script[src*="adsbygoogle"]')) {
      const adsScript = document.createElement('script');
      adsScript.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3041826185319356';
      adsScript.async = true;
      adsScript.setAttribute('crossorigin', 'anonymous');
      document.head.appendChild(adsScript);
    }
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-2384" data-mp="aus31o269s5j">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2385" data-mp="ft3do10ak6ot">
        {/* Header */}
        <header className="mb-12 text-center" data-id="element-2386" data-mp="orkpsp5rdjqt">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-2387" data-mp="jtssffmch5f8">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2388" data-mp="xna6wm06brye" />
            Back to Home
          </Link>
          <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight leading-tight mb-4" data-id="element-2389" data-mp="tkdujd188s2w">
            The IntelliEats Blog
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-2390" data-mp="vou7g7zwqs7">
            Insights, guides, and tips to help you understand what's really in
            your food and make smarter choices.
          </p>
        </header>

        {/* Post List */}
        <div className="space-y-8" data-id="element-2391" data-mp="9xppi7jo52r8">
          {blogPosts.map((post, index) => <motion.div key={post.slug} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-2392" data-mp="1q80cy71gu9xc" data-mpi={index}>
              <Link to={`/blog/${post.slug}`} className="group block bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden" data-id="element-2393" data-mp="rxsgbj6fj94k">
                <div className="grid sm:grid-cols-5 gap-0" data-id="element-2394" data-mp="51f0u9w2u8g">
                  <div className="sm:col-span-2 relative overflow-hidden" data-id="element-2395" data-mp="4999l83134el">
                    <img src={post.image} alt={post.imageAlt} className="w-full h-48 sm:h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-2396" data-mp="97ap5j18wllb" />
                    <span aria-hidden="true" className="pointer-events-none absolute bottom-2 right-2 select-none rounded-full bg-white/70 px-2 py-0.5 text-[10px] font-black tracking-tight backdrop-blur-sm" data-id="element-2397" data-mp="3cm6pfqu4nd3i">
                      <span className="text-slate-900/70" data-id="element-2398" data-mp="3559w257tjeov">Intelli</span>
                      <span className="text-brand-600/80" data-id="element-2399" data-mp="304vwlbka9d2g">Eats</span>
                    </span>
                  </div>
                  <div className="sm:col-span-3 p-6 sm:p-8 flex flex-col justify-center" data-id="element-2400" data-mp="2w3acb55f5wi8">
                    <div className="flex items-center gap-3 mb-3" data-id="element-2401" data-mp="2r60pzydbu0ym">
                      <span className="px-3 py-1 rounded-full bg-brand-50 text-brand-700 text-xs font-bold tracking-wider uppercase" data-id="element-2402" data-mp="2meip1abb00dn">
                        {post.category}
                      </span>
                      <span className="flex items-center text-xs text-slate-400" data-id="element-2403" data-mp="2cgcmqrll4s89">
                        <Clock className="w-3 h-3 mr-1" data-id="element-2404" data-mp="28ehpby6ryyzr" />
                        {post.readTime}
                      </span>
                    </div>
                    <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 leading-snug group-hover:text-brand-700 transition-colors" data-id="element-2405" data-mp="23gplc5suvmf7">
                      {post.title}
                    </h2>
                    <p className="text-slate-600 text-sm leading-relaxed mb-4 line-clamp-3" data-id="element-2406" data-mp="bdbutmozl2nf">
                      {post.excerpt}
                    </p>
                    <span className="inline-flex items-center text-sm font-semibold text-brand-600 group-hover:text-brand-700" data-id="element-2407" data-mp="2l9z21pv4ajh">
                      Read Article
                      <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-2408" data-mp="3jvrii02aqrm6" />
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </motion.div>;
}